import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext({ settings: null });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);
  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
